import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "oim_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

http.interceptors.response.use(
  (r) => r,
  (err) => {
    // Expired/invalid session — drop the token and let AuthContext show the login screen
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      clearToken();
      window.dispatchEvent(new Event("oim:unauthorized"));
    }
    return Promise.reject(err);
  }
);

export const api = {
  authConfig:   () => http.get(`/auth/config`).then(r => r.data),
  login:        (username, password) => http.post(`/auth/login`, { username, password }).then(r => r.data),
  logout:       () => http.post(`/auth/logout`).then(r => r.data),
  state:        () => http.get(`/state`).then(r => r.data),
  twins:        () => http.get(`/twins`).then(r => r.data),
  twin:         (key) => http.get(`/twin/${key}`).then(r => r.data),
  resources:    () => http.get(`/resources`).then(r => r.data),
  sustain:      () => http.get(`/sustainability`).then(r => r.data),
  opportunities:() => http.get(`/opportunities`).then(r => r.data),
  sparkline:    (kpi, n=40) => http.get(`/sparkline/${kpi}?n=${n}`).then(r => r.data),
  catalog:      () => http.get(`/anomalies/catalog`).then(r => r.data),
  inject:       (key, severity) => http.post(`/anomalies/inject`, { key, severity }).then(r => r.data),
  clearAll:     () => http.post(`/anomalies/clear`).then(r => r.data),
  scenarios:    () => http.get(`/scenarios`).then(r => r.data),
  applyScenario:(key) => http.post(`/scenarios/${key}`).then(r => r.data),
  control:      (body) => http.post(`/simulation/control`, body).then(r => r.data),
  aiNewSession: () => http.post(`/ai/session`).then(r => r.data),
  aiChat:       (session_id, message) => http.post(`/ai/chat`, { session_id, message }).then(r => r.data),
};

export const ROLES = [
  { key: "executive", label: "Executive" },
  { key: "plant_head", label: "Plant Head" },
  { key: "ops", label: "Operations Manager" },
  { key: "sustain", label: "Sustainability Manager" },
  { key: "admin", label: "Administrator" },
];

export const fmtINR = (v) => {
  if (v == null || isNaN(v)) return "—";
  const a = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (a >= 1e7) return `${sign}₹${(a / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `${sign}₹${(a / 1e5).toFixed(2)} L`;
  if (a >= 1e3) return `${sign}₹${(a / 1e3).toFixed(1)}k`;
  return `${sign}₹${a.toFixed(0)}`;
};

export const fmtNum = (v, digits = 1) => {
  if (v == null || isNaN(v)) return "—";
  return Number(v).toFixed(digits);
};

export const fmtAgo = (ts) => {
  if (!ts) return "—";
  const s = Math.max(0, Math.round((Date.now() / 1000) - ts));
  if (s < 60) return `${s}s ago`;
  return `${Math.floor(s / 60)}m ${s % 60}s ago`;
};
